/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Move_CancelInputs */

const en_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_explorer_nav_move_cancel = /** @type {(inputs: Explorer_Nav_Move_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Explorer_Nav_Move_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_move_cancel = /** @type {((inputs?: Explorer_Nav_Move_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Move_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_move_cancel(inputs)
	if (locale === "de") return de_explorer_nav_move_cancel(inputs)
	if (locale === "it") return it_explorer_nav_move_cancel(inputs)
	if (locale === "ru") return ru_explorer_nav_move_cancel(inputs)
	if (locale === "es") return es_explorer_nav_move_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_move_cancel(inputs)
	if (locale === "ja") return ja_explorer_nav_move_cancel(inputs)
	if (locale === "hi") return hi_explorer_nav_move_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_move_cancel(inputs)
	return en_explorer_nav_move_cancel(inputs)
});